/** Texty súhlasu so zdieľaním dát s AI (App Store 5.1.2(i)) — AI asistent a AI popis nehnuteľnosti. */
export const AI_CONSENT_TITLE = 'AI funkcie využívajú službu OpenAI'

export const AI_CONSENT_POINTS: readonly string[] = [
  'Text vašich otázok asistentovi, priložené súbory (fotky, PDF, dokumenty) a hlasové nahrávky (na prepis do textu) sa odosielajú spoločnosti OpenAI (USA).',
  'Asistent pri odpovedi načíta údaje z CRM, ktoré sú na odpoveď potrebné — napr. nehnuteľnosti, kontakty, udalosti alebo e-maily a ich prílohy — a tie sa tiež odošlú OpenAI.',
  'Pri generovaní popisu nehnuteľnosti sa OpenAI odošlú jej parametre, poloha a náhľady fotiek.',
  'OpenAI tieto údaje nepoužíva na trénovanie svojich modelov. Hlasové nahrávky neukladáme, priložené súbory zmažeme spolu s konverzáciou.',
  'Súhlas môžete kedykoľvek odvolať v Nastaveniach. Bez súhlasu AI asistent a AI popis nie sú dostupné, ostatné funkcie aplikácie fungujú bez obmedzenia.',
]

export const AI_CONSENT_ACCEPT = 'Súhlasím'
export const AI_CONSENT_DECLINE = 'Nie, ďakujem'

export const PRIVACY_POLICY_URL =
  'https://files.realnexa.sk/realnexa-prod/legal/zasady-ochrany-osobnych-udajov.html'
